var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41082 13.0158L13.0158 4.41083C13.3408 4.08583 13.8683 4.08583 14.1933 4.41083L15.59 5.8075C15.915 6.1325 15.915 6.66 15.59 6.985L6.98416 15.5892C6.82832 15.7458 6.61666 15.8333 6.39582 15.8333H4.16666V13.6042C4.16666 13.3833 4.25416 13.1717 4.41082 13.0158V13.0158Z",
    stroke: "#D1C5F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 5.96666L14.0333 8.54166",
    stroke: "#D1C5F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b7302adcb8b44ef81774c77b14dd478b.svg";
export { ForwardRef as ReactComponent };